import {useQuery} from '@tanstack/react-query'

import {cacheKeys} from 'api'
import {TokenInfo} from 'constData'

import useApi from '../api/useApi'

import useProfile from './useProfile'

const useTokenConvertQuery = asset => {
  const api = useApi()
  const {profile} = useProfile()

  const eligibilityQuery = useQuery(
    [cacheKeys.tokenConvertEligibility, asset],
    () => {
      if (!profile) return null
      return api.getTokenConvertEligibility({userId: profile.id})
    },
    {
      enabled:
        asset === TokenInfo.V999.apiId || asset === 'GNS' || asset === 'V999GNS' ? true : false,
    },
  )

  return {
    ...eligibilityQuery,
  }
}

export default useTokenConvertQuery
